export const API_URI = process.env.REACT_APP_BACKEND_URL;

export const getURL = (baseUrl, params) => {
  const searchParamsKeys = Object.keys(params);
  let url = "";
  searchParamsKeys.map((param, index) => {
    url +=
      index === searchParamsKeys.length - 1
        ? `${param}=${params[param]}`
        : `${param}=${params[param]}&`;
    return null;
  });
  return `${baseUrl}?${url}`;
};

export const urls = {
  USER_SOURCE_ALL: `${API_URI}/user/sources/bulk-select/`,
  USER_SOURCE: `${API_URI}/user/sources/`,
  SOURCES: `${API_URI}/sources/`,
  FOLDERS: `${API_URI}/folders/`,
  REPORTS: `${API_URI}/reports/`,
  ARTICLES: `${API_URI}/articles/`,
  USER: `${API_URI}/user/`,
  USERS: `${API_URI}/users/`,
  TOKEN: `${API_URI}/token/`,
  TOKEN_GOOGLE: `${API_URI}/users/google/`,
  TOKEN_REFRESH: `${API_URI}/token/refresh/`,
  CHANGE_PASSWORD: `${API_URI}/user/password/`,
  PROFILE: `${API_URI}/profiles/`,
  SOURCE_ALL: `${API_URI}/user/sources/bulk-create-destroy/`,
  LABEL: `${API_URI}/labels/`,
};
